import React, { useEffect, useState } from 'react';
import { ChevronRight, Mail, Phone } from 'lucide-react';
const US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
export function MailingListPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: ''
  });
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section className="bg-cream" data-id="element-661">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-662">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-663">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-664">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-665">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-666" />
            <span className="text-charcoal font-medium" data-id="element-667">Mailing List</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-668">
            Join Our Mailing List
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-669">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-670">
          {/* Main Content */}
          <div className="lg:w-2/3" data-id="element-671">
            {submitted ? <div className="bg-white p-10 md:p-14 rounded-sm shadow-sm border border-warmBorder text-center" data-id="element-672">
                <div className="w-16 h-16 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-6" data-id="element-673">
                  <Mail className="w-8 h-8 text-sage" data-id="element-674" />
                </div>
                <h2 className="text-2xl font-serif text-charcoal mb-4" data-id="element-675">
                  Thank You for Subscribing!
                </h2>
                <p className="text-warmGray text-lg leading-relaxed max-w-md mx-auto mb-8" data-id="element-676">
                  You've been added to the Switchplate Gallery mailing list.
                  We'll keep you updated with new designs, special offers, and
                  inspiration.
                </p>
                <a href="#/" className="inline-flex items-center px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-677">
                  Continue Shopping
                </a>
              </div> : <>
                <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder mb-8" data-id="element-678">
                  <div className="mb-8" data-id="element-679">
                    <h2 className="text-2xl font-serif text-charcoal mb-3" data-id="element-680">
                      Subscribe to Our Mailing List
                    </h2>
                    <p className="text-warmGray leading-relaxed" data-id="element-681">
                      Stay in the loop! Receive exclusive offers, new product
                      announcements, and home décor inspiration. Fill in the
                      information below and click "Subscribe" — you'll be
                      automatically added to our mailing list.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-5" data-id="element-682">
                    {/* Name */}
                    <div data-id="element-683">
                      <label htmlFor="name" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-684">
                        Name
                      </label>
                      <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Your full name" data-id="element-685" />
                    </div>

                    {/* Email */}
                    <div data-id="element-686">
                      <label htmlFor="email" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-687">
                        E-Mail
                      </label>
                      <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="your@email.com" data-id="element-688" />
                    </div>

                    {/* Mailing Address */}
                    <div data-id="element-689">
                      <label htmlFor="address" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-690">
                        Mailing Address
                      </label>
                      <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Street address" data-id="element-691" />
                    </div>

                    {/* City / State / Zip row */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-692">
                      <div data-id="element-693">
                        <label htmlFor="city" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-694">
                          City
                        </label>
                        <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="City" data-id="element-695" />
                      </div>
                      <div data-id="element-696">
                        <label htmlFor="state" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-697">
                          State
                        </label>
                        <select id="state" name="state" value={formData.state} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all appearance-none" style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B6560' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 12px center'
                    }} data-id="element-698">
                          <option value="" data-id="element-699">Select...</option>
                          {US_STATES.map(s => <option key={s} value={s} data-id="element-700">
                              {s}
                            </option>)}
                        </select>
                      </div>
                      <div data-id="element-701">
                        <label htmlFor="zip" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-702">
                          Zip Code
                        </label>
                        <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Zip" maxLength={10} data-id="element-703" />
                      </div>
                    </div>

                    <div className="pt-4" data-id="element-704">
                      <button type="submit" className="w-full sm:w-auto px-12 py-4 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider shadow-lg" data-id="element-705">
                        Subscribe
                      </button>
                    </div>
                  </form>
                </div>

                <div className="bg-cream-dark p-6 rounded-sm border border-warmBorder" data-id="element-706">
                  <p className="text-warmGray text-sm leading-relaxed" data-id="element-707">
                    <strong className="text-charcoal" data-id="element-708">
                      Already subscribed?
                    </strong>{' '}
                    If you need to update your information or unsubscribe,
                    please{' '}
                    <a href="#/contact" className="text-gold hover:text-gold-dark font-bold underline underline-offset-4 transition-colors" data-id="element-709">
                      contact us
                    </a>{' '}
                    and we'll be happy to help. We respect your privacy and will
                    never share your information.
                  </p>
                </div>
              </>}
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-710">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-711">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-712">
                Why Subscribe?
              </h4>
              <ul className="space-y-4 text-warmGray" data-id="element-713">
                <li className="flex items-start gap-3" data-id="element-714">
                  <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-715" />
                  <span data-id="element-716">Be the first to see new switchplate designs</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-717">
                  <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-718" />
                  <span data-id="element-719">Exclusive subscriber-only offers &amp; discounts</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-720">
                  <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-721" />
                  <span data-id="element-722">Home décor tips &amp; inspiration</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-723">
                  <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-724" />
                  <span data-id="element-725">Seasonal collections &amp; gift ideas</span>
                </li>
              </ul>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-726">
                <p className="text-sm text-warmGray mb-2 uppercase tracking-wider font-bold" data-id="element-727">
                  Questions?
                </p>
                <a href="tel:8004976946" className="text-2xl font-serif text-gold hover:text-gold-dark transition-colors" data-id="element-728">
                  800.497.6946
                </a>
                <p className="text-xs text-warmGray mt-1" data-id="element-729">
                  Available 9AM–5PM EST
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}